import React from "react";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <>
      <Typography component="p">{t("notfound.content")}</Typography>
    </>
  );
}
